import PassThrough from '@/components/PassThrough';

const FitnessCommunityPage = () => import(/* webpackChunkName: "group-communities" */ '@/pages/communityPages/FitnessCommunityPage');

export default {
  path: 'c',
  component: PassThrough,
  children: [
    {
      path: 'fitness',
      name: 'FitnessCommunityPage',
      component: FitnessCommunityPage,
    },
  ],
};
